import { Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AddMembreComiteComponent } from "./add-membre-comite/add-membre-comite.component";
import { EditMembreComiteComponent } from "./edit-membre-comite/edit-membre-comite.component";
import { MembreComite } from "../core/model/membre-comite";
import { MembreComiteService } from "../core/service/membre-comite.service";

@Component({
  selector: "app-membre-comite",
  templateUrl: "./membre-comite.component.html",
  styleUrls: ["./membre-comite.component.scss"],
})
export class MembreComiteComponent implements OnInit {
  membreComites: MembreComite[];

  constructor(
    private _membreComiteService: MembreComiteService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.getAllMembreComites();
  }

  getAllMembreComites() {
    this._membreComiteService.getAllMembreComites().subscribe(
      (data) => {
        this.membreComites = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  add(): void {
    const modalRef = this.modalService.open(AddMembreComiteComponent, {
      centered: true,
    });

    modalRef.result.then(
      (data) => {
        // on close
        this.getAllMembreComites();
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  edit(membreComite: MembreComite): void {
    const modalRef = this.modalService.open(EditMembreComiteComponent, {
      centered: true,
    });
    modalRef.componentInstance.membreComite = membreComite;

    modalRef.result.then(
      (updated: MembreComite) => {
        if (updated && this.membreComites) {
          const index = this.membreComites.findIndex(
            (m) => m.id === updated.id
          );
          if (index !== -1) {
            this.membreComites[index] = updated;
            this.membreComites = [...this.membreComites];
            return;
          }
        }
        this.getAllMembreComites();
      },
      (reason) => {
        // on dismiss
      }
    );
  }
}
